import type { Component } from 'vue';
import type { SearchCriteria } from '@/entities/searchCriteria';

export enum SerpBannerId {
  Lead = 'lead',
  Emirates = 'emirates',
  AppInstall = 'appInstall',
  LearnDiscount = 'learnDiscount',
  DreamTour = 'dreamTour',
  Hacks8 = 'hacks8',
  Subscribe = 'subscribe',
  GiftCertificates = 'giftCertificates',
  A51 = 'a51',
}

export type SerpBannerRepeat = 'once' | 'repeat';

export interface SerpBannerContext {
  searchCriteria: SearchCriteria;
  totalCards: number;
  isAlternativeSearch: boolean;
  isShortSerp: boolean;
}

export interface SerpBanner {
  id: SerpBannerId;
  component: Component;
  repeat: SerpBannerRepeat;
  isEnabled?: (context: SerpBannerContext) => boolean;
  preload?: () => void;
}

export interface SerpBannersGrid {
  anchor: number;
  step: number;
}

export interface SerpStaticBanner {
  id: SerpBannerId;
  cardPosition: number;
  dynamicGrid?: SerpBannersGrid;
}

export interface SerpBannerSlot {
  cardPosition: number;
  bannerId: SerpBannerId;
}

export enum A51BannerState {
  Loading = 'loading',
  Loaded = 'loaded',
  Stub = 'stub',
}
